import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';

export default function NotFound() {
  return (
    <SiteLayout>
      <section className="relative flex min-h-[80vh] items-center overflow-hidden bg-foreground-950 pb-20 pt-40">
        <div className="absolute inset-0 hatch-lines-light opacity-25" />
        <div className="container-wide relative z-10">
          <p className="label-mono text-primary-300">Erreur 404</p>
          <h1 className="display-title mt-5 max-w-3xl text-5xl text-background-50 sm:text-6xl lg:text-7xl">
            Cette page n'existe pas
            <br />
            <span className="text-primary-400">— ou plus.</span>
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-background-300">
            Le lien est peut-être obsolète. Revenez à l'accueil ou consultez directement nos
            expertises industrielles.
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-background-50 transition-colors hover:bg-primary-600"
            >
              Retour à l'accueil
              <i className="ri-arrow-right-line text-base" />
            </Link>
            <Link
              to="/offres"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-7 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-background-50 transition-colors hover:bg-background-50 hover:text-foreground-950"
            >
              Voir nos offres
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}